module.exports = __webpack_public_path__ + "static/media/bettr-tasks-dark.8bf6baae.png";